"use client";
import { ButtonBase } from "@mui/material";

import ToolTip from "../Tooltip";
import { _Icon } from "./index";

const ButtonFilled = ({
  selected,
  IconStart,
  IconEnd,
  tooltip,
  label = "",
  fullWidth,
  size = "medium",
  disabled = false,
  sx,
  ...props
}) => (
  <ToolTip title={tooltip} sx={fullWidth ? { width: "100%" } : undefined}>
    <ButtonBase
      disabled={disabled}
      sx={theme => ({
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pl: label ? undefined : 1,
        borderRadius: "var(--shape-round)",
        width: fullWidth ? "100%" : undefined,
        height: size === "small" ? 32 : size === "large" ? 56 : 40,
        bgcolor: disabled
          ? theme.addAlpha("var(--surface-on-color)", 0.12)
          : "var(--primary-color)",
        transition: "all 250ms",
        typography: {
          compact: size === "large" ? "titleMd" : "labelMd",
          expanded:
            size === "large"
              ? "titleMd"
              : `label${size === "small" ? "Md" : "Lg"}`
        },
        color: disabled
          ? theme.addAlpha("var(--surface-on-color)", 0.38)
          : "var(--primary-on-color)",
        backgroundImage: disabled
          ? undefined
          : `linear-gradient(${theme.addAlpha(
              "var(--secondary-on-container)",
              0.08
            )}, ${theme.addAlpha("var(--secondary-on-container)", 0.08)})`,
        "&:hover": {
          bgcolor: disabled
            ? theme.addAlpha("var(--surface-on-color)", 0.12)
            : theme.addAlpha("var(--primary-color)", 0.8),
          boxShadow: "var(--elevation-1)",
          backgroundImage: disabled
            ? undefined
            : `linear-gradient(${theme.addAlpha(
                "var(--surface-on-variant)",
                0.08
              )}, ${theme.addAlpha("var(--surface-on-variant)", 0.08)})`
        },
        ...sx
      })}
      {...props}
    >
      {IconStart ? (
        <_Icon
          color="var(--primary-on-color)"
          Icon={IconStart}
          disabled={disabled}
        />
      ) : (
        <span />
      )}
      {label}
      {IconEnd ? (
        <_Icon
          end
          color="var(--primary-on-color)"
          Icon={IconEnd}
          disabled={disabled}
        />
      ) : (
        <span />
      )}
    </ButtonBase>
  </ToolTip>
);

export default ButtonFilled;
